/* eslint-disable import/prefer-default-export */
export const STAT_CLASSES =
  "tw-flex-1 tw-min-h-[124px] tw-min-w-[150px] tw-border-solid tw-border-neutral-gray-10 tw-border-y-0 tw-border-l-0 tw-border-r-[1px] last-of-type:tw-border-0 first-of-type:tw-pl-0";
